import React, { useEffect, useState } from "react";
import { GetPetsByWithPlanPatientId } from "../../services/petService";
import { useStateAuthValue } from "../../context/Auth/AuthState";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useHistory } from "react-router";
import DogIcon from "../../assets/img/dog.svg";
import { currencyFormatArgentina } from "../../utils/currency-util";

export const MyPlanPage = () => {
  const [{ userData, userToken }] = useStateAuthValue();
  const [loading, setLoading] = useState(true);
  const [pets, setPets] = useState([]);
  const history = useHistory();

  const getMyPets = async () => {
    try {
      setLoading(true);
      const res = await GetPetsByWithPlanPatientId(
        userData.patient_dto.id,
        userToken
      );
      const data = res.data;
      setPets(data);
    } catch (e) {
      // console.log({ e });
    } finally {
      setLoading(false);
    }
  };

  const myPlanHandler = (typeClick = "addPet") => {
    history.push("/mi-plan-modal", { typeClick: typeClick });
  };

  useEffect(() => {
    if (
      typeof userData === "object" &&
      userData !== null &&
      !Array.isArray(userData)
    ) {
      getMyPets();
      // getPlan();
    }
  }, [userData]);

  return (
    <div>
      <div className="container">
        <div className="title_container">
          <h2>Mi Plan</h2>
        </div>
        <div>
          <div>
            <h5 style={{ padding: "10px 0" }}>
              Titular: {userData?.first_name + " " + userData?.last_name}
            </h5>
          </div>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div className="table-responsive">
              <table className="table table-striped text-center">
                <thead>
                  <tr className="table-primary">
                    <th scope="col">#</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Especie</th>
                    <th scope="col">Raza</th>
                    <th scope="col">Sexo</th>
                    <th scope="col">Plan</th>
                    <th scope="col">Precio</th>
                  </tr>
                </thead>
                <tbody>
                  {pets.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-5">
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={DogIcon}
                            alt="Sin mascotas"
                            style={{
                              width: "80px",
                              height: "80px",
                              opacity: 0.6,
                              marginBottom: "15px",
                            }}
                          />
                          <p
                            className="text-muted mb-1"
                            style={{ fontSize: "16px" }}
                          >
                            No tienes mascotas registradas aún
                          </p>
                          <small className="text-muted">
                            Haz clic en &quot;Agregar Mascota&quot; para
                            comenzar
                          </small>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    pets.map((member, index) => (
                      <tr key={index}>
                        <td scope="row">{index + 1}</td>
                        <td>{member.name}</td>
                        <td>{member.species}</td>
                        <td>{member.race}</td>
                        <td>{member.sexo === "MALE" ? "Macho" : "Hembra"}</td>
                        <td>{member.plan}</td>
                        <td>{currencyFormatArgentina(member?.precio || 0)}</td>
                        {/* <td>
                        {member && (
                          <div>
                            <img
                              id={member?.id ? member?.id : ""}
                              src={TrashIcon}
                              style={{ cursor: "pointer" }}
                              className="icon"
                              alt="Item menú"
                              onClick={deleteFamilyGroupMember}
                            />
                            <img
                              id={member?.id ? member?.id : ""}
                              src={PencilIcon}
                              style={{ cursor: "pointer" }}
                              className="icon"
                              alt="Item menú"
                              onClick={() => editFamilyMember(member.id)}
                            />
                          </div>
                        )}
                      </td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="button-container">
            <button
              className="button add-button-plan"
              onClick={() => myPlanHandler("addPet")}
            >
              Agregar Mascota
            </button>
            <button
              className="button see-plan-button"
              onClick={() => myPlanHandler("changePlan")}
            >
              Cambio de Plan
            </button>
            <button
              className="button close-button-plan"
              // className="button see-plan-button"
              onClick={() => {
                history.goBack();
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
